.root {
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0;
  font-weight: var(--font-weight-regular);

  & > * {
    margin-top: 0.25rem;
  }
}

.block {
  width: 100%;
}
